import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { DictionaryClientDataRequestType } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { PartnerAPIService } from 'src/app/extensions/services/api/partner-api.service';
import { FilesHandler } from '../../utils/files-handler';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { isNotEmpty } from 'src/app/extensions/utilities';
import { SIGNAL_ITEM_KEY } from 'src/app/extensions/constants/commonConstants';

@Component({
  selector: 'app-add-owner-request',
  templateUrl: './add-beneficial-owner-request.component.html',
  styleUrls: ['./add-beneficial-owner-request.component.scss'],
  standalone: false,
})
export class AddOwnerInformationRequestComponent implements OnInit {
  @ViewChild('form') public form: NgForm;

  clientDataRequestSaveModel: app.models.ClientDataRequestSaveModel = {
    beneficialOwner: {},
    documentsAttached: [],
  } as app.models.ClientDataRequestSaveModel;

  isSendButtonDisabled: boolean = false;

  private stateSignalItem: any;

  constructor(
    private _globalService: GlobalService,
    private _router: Router,
    private _dictionaryService: DictionaryAPIService,
    private _partnerService: PartnerAPIService,
    public _filesHandler: FilesHandler,
    private _activatedRoute: ActivatedRoute
  ) {
    this.stateSignalItem = this._globalService.getSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA);

    if (isNotEmpty(this.stateSignalItem)) {
      this.clientDataRequestSaveModel = this.stateSignalItem.data as app.models.ClientDataRequestSaveModel;
      this.isSendButtonDisabled = this.stateSignalItem.extras?.isSendButtonDisabled;
    }
  }

  ngOnInit(): void {
    if (!isNotEmpty(this.stateSignalItem)) {
      this.loadData();
    }
  }

  loadData() {
    let source = forkJoin([this._partnerService.getCompanyInfo(), this._dictionaryService.getClientDataRequestTypes()]);
    source.subscribe(([clientData, dictionaryClientDataRequestTypes]) => {
      if (clientData.data) {
        this.clientDataRequestSaveModel.partnerExternalEntityId = clientData.data.partnerExternalEntityId;
      }

      if (dictionaryClientDataRequestTypes.data) {
        let beneficialOwnerRequestType = dictionaryClientDataRequestTypes.data.find(
          x => x.code == DictionaryClientDataRequestType.BeneficialOwner
        );
        if (beneficialOwnerRequestType) {
          this.clientDataRequestSaveModel.dictionaryClientDataRequestTypeId = beneficialOwnerRequestType.id;
          this.clientDataRequestSaveModel.description = beneficialOwnerRequestType.description;
          this.isSendButtonDisabled = false;
        }
      }
    });
  }

  sendRequestCofirmationHandler() {
    if (this.form.invalid) {
      return;
    }

    this.stateSignalItem = {
      data: this.clientDataRequestSaveModel,
      extras: {
        isSendButtonDisabled: this.isSendButtonDisabled,
      },
      routePath: this._activatedRoute.snapshot.routeConfig.path,
    };
    this._globalService.setSignalItem(SIGNAL_ITEM_KEY.RQST_CLIENT_DATA, this.stateSignalItem);
    this._router.navigate(['requests/client-data/new/request-preview']);
  }

  redirectListHandler = () => {
    this._router.navigate(['requests/client-data']);
  };

  redirectFieldSelectionHandler() {
    this._router.navigate(['requests/client-data/new']);
  }
}
